import { useMutation } from '@apollo/client'
import { removeInitiative as removeInitiativeGql }
   from 'src/graphql/mutations/removeInitiative.gql'

const useRemoveInitiative = (mutationHookOptions = {}) => {
   const [removeInitiative, { called, client, data, error, loading }] = useMutation(
      removeInitiativeGql,
      {
         refetchQueries: ['getInitiativeList'],
         ...mutationHookOptions
      }
   )

   const wrappedMutationFn = (variables, mutationFnOptions) => removeInitiative({
      variables,
      ...mutationFnOptions
   })

   return {
      removeInitiative: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useRemoveInitiative
